import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import chair from "../../assets2/images/Chair.svg";
import houses from "../../assets2/images/houses.svg";
import people from "../../assets2/images/people.svg";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { useNavigate } from "react-router-dom";
import { usePreview } from "../../context/previewContext";
import { BsThreeDotsVertical } from "react-icons/bs";
import { toast } from "react-toastify";
import { base_URL } from "../../config/config";
import axios from "axios";
import { useSelector } from "react-redux";
import MovetoOtherFolderModal from "./MovetoOtherFolderModal";
import { RxCross2 } from "react-icons/rx";
import VenueCard from "../shared/card/venue/VenueCard";
import { getS3Thumb } from "../../utils/utilityFunctions";
import SecureImg from "../shared/SecureImg";

const VenueFavoriteDetail = ({
	data,
	name,
	refetch,
	isCompareMode,
	onSelect,
	setCompareType,
	handleRemove,
	handleCompare,
	selectedVenues,
	setIsCompareMode,
	compareType,
	isBulkEnquiry,
	clearSelectedVenues,
	selectedEnquiries,
	handleBulkEnquiry,
	handleEnquiryRemove,
	onEnquirySelect,
	setEnquiryType,
	enquiryType,
	setIsBulkEnquiry,
}) => {
	const [isMobileView, setIsMobileView] = useState(false);
	const [isSelectedCompare, setIsSelectedCompare] = useState(false);
	const [minSpendPricing, setMinSpendPricing] = useState(null);
	const [minSpendPerPerson, setMinSpendPerPerson] = useState(null);
	const [venueRental, setVenueRental] = useState(null);
	const user = useSelector((state) => state.auth.user);
	const [options, setOptions] = useState(false);
	const navigate = useNavigate();
	const { setPreviewData } = usePreview();
	const [moveToOther, setMoveToOther] = useState(false);
	const [itemId, setItemId] = useState(null);

	if (isMobileView) {
		console.log("");
	}

	const calculateMinSpendFromSelectedOptions = () => {
		if (data?.pricing) {
			let selectedOptions = [];
			if (data?.pricing?.["Minimum Spend Pricing"]) {
				selectedOptions = [
					...selectedOptions,
					{
						type: "Minimum Spend Pricing",
						details: data?.pricing["Minimum Spend Pricing"][0],
					},
				];
			}
			if (data?.pricing?.["Venue Rental"]) {
				selectedOptions = [
					...selectedOptions,
					{ type: "Venue Rental", details: data?.pricing["Venue Rental"][0] },
				];
			}
			if (data?.pricing?.["Min spend per person"]) {
				selectedOptions = [
					...selectedOptions,
					{
						type: "Min spend per person",
						details: data?.pricing["Min spend per person"][0],
					},
				];
			}
			let minSpendPricing = null;
			let venueRental = null;
			let minSpendPerPerson = null;
			let hasMinimumSpendPricing = false;

			selectedOptions.forEach((option) => {
				const minSpendValue = Number(option?.details?.minSpend || undefined);
				if (
					option?.details?.type === "Venue Rental" &&
					option?.details?.minSpend
				)
					venueRental = option?.details?.minSpend;

				if (minSpendValue !== undefined && !Number.isNaN(minSpendValue)) {
					switch (option.type) {
						case "Minimum Spend Pricing":
							hasMinimumSpendPricing = true; // Flag that "Minimum Spend Pricing" exists
							minSpendPricing =
								minSpendPricing === null
									? minSpendValue
									: Math.min(minSpendPricing, minSpendValue);
							break;

						case "Venue Rental":
							// Only use Venue Rental if Minimum Spend Pricing isn't available
							venueRental =
								venueRental === null
									? minSpendValue
									: Math.min(venueRental, minSpendValue);
							break;

						case "Min spend per person":
							minSpendPerPerson =
								minSpendPerPerson === null
									? minSpendValue
									: Math.min(minSpendPerPerson, minSpendValue);
							break;

						default:
							break;
					}
				}
			});

			// Set the calculated minimum spend values to the state
			setMinSpendPricing(minSpendPricing);
			setMinSpendPerPerson(minSpendPerPerson);
			setVenueRental(venueRental);
		} else {
			// If no selected options are present, reset all values to null
			setMinSpendPricing(null);
			setMinSpendPerPerson(null);
			setVenueRental(null);
		}
	};
	useEffect(() => {
		calculateMinSpendFromSelectedOptions();
	}, [data]);

	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth < 1024); // lg breakpoint in Tailwind
		};

		window.addEventListener("resize", handleResize);

		handleResize(); // Set initial value

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleViewPreviewDetails = () => {
		const cf = "dhpv";
		const venueId = data?._id;
		const slug = data?.basicDetails?.venueName
			?.toLowerCase()
			?.replace(/[^a-z0-9]+/g, "-")
			?.replace(/(^-|-$)/g, "");
		const venueName = data?.basicDetails?.venueName || "Venue";
		navigate(`/preview/${cf}/${venueId}/${slug}`, {
			state: {
				breadcrumbPath: [
					{ name: "Home", to: "/" },
					{ name: "My Favorites", to: "/my-favorites" },
					{ name: name, to: `/favorite-detail/${user?._id}/${name}` },
					{ name: venueName, to: "" },
				],
			},
		});
	};

	const handleDelete = async () => {
		try {
			await fetch(`${base_URL}/api/auth/delete-folder`, {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					customerId: user?._id,
					folderName: name,
				}),
			});
		} catch (error) {
			console.log(error);
		}
	};

	const removeHandle = async (itemId) => {
		try {
			const response = await axios.put(`${base_URL}/api/auth/unfav-item`, {
				customerId: user?._id,
				itemId,
				type: "venues",
				folderName: name,
			});
			const data = await response.data;
			if (
				data.folder.venues.length === 0 &&
				data.folder.venuesAndStay.length === 0
			) {
				await handleDelete();
			}

			toast.success(`Successfully removed from ${name}`);
			refetch();
			navigate("/my-favorites");
		} catch (error) {
			console.log(error);
		}
	};

	const getVenuActivity = (data) => {
		if (data?.additionalDetails?.venueSetting?.length === 1) {
			if (data?.additionalDetails?.venueSetting[0] === "Indoor + Outdoor")
				return "Indoor & Outdoor";
			else return data?.additionalDetails?.venueSetting[0];
		} else if (data?.additionalDetails?.venueSetting?.length > 1)
			return data?.additionalDetails?.venueSetting.join(" & ");
		else return "Indoor & Outdoor";
	};

	const moveHandle = (id) => {
		// console.log("clicked");
		setItemId(id);
		setMoveToOther(true);
	};

	const overlayComp = () => {
		return (
			<>
				<div
					className="bg-white absolute top-3 right-5 p-1.5 rounded-full cursor-pointer z-50"
					onClick={(e) => {
						e.stopPropagation();
						setOptions(!options);
					}}
				>
					<BsThreeDotsVertical size={20} />
				</div>
				{options && (
					<div className="bg-white absolute top-12 right-8 rounded-md w-40 z-0 flex flex-col justify-center items-center">
						<div
							className="text-[14px] cursor-pointer py-3 px-3"
							onClick={() => removeHandle(data?._id)}
						>
							Unfavorite
						</div>
						<div
							className="text-[14px] cursor-pointer py-3 px-3"
							onClick={() => moveHandle(data?._id)}
						>
							Move to other list
						</div>
					</div>
				)}
			</>
		);
	};

	return (
		<>
			{moveToOther && (
				<MovetoOtherFolderModal
					isOpen={moveToOther}
					onClose={() => setMoveToOther(false)}
					data={user.favoritesFolder}
					type={"venues"}
					itemId={itemId}
					preName={name}
				/>
			)}
			<VenueCard
				onClick={() => handleViewPreviewDetails()}
				className={`${isCompareMode ? "mb-0 " : "mb-20"} ${
					isBulkEnquiry ? "mb-0 " : "mb-20"
				}`}
				// className="mb-20"
			>
				<VenueCard.Slider images={data?.imagesAndVideos?.images}>
					{overlayComp()}
				</VenueCard.Slider>
				<VenueCard.Details>
					<VenueCard.VenueName>
						{data?.basicDetails?.venueName || "Undefined"},{" "}
						{data?.basicDetails?.hotelName || "Undefined"}
					</VenueCard.VenueName>
					<VenueCard.Location>
						{data?.location?.city || "Undefined"},{" "}
						{data?.location?.area || "Undefined"}
					</VenueCard.Location>
					<VenueCard.Icons
						chair={chair}
						standing={people}
						sittingCapacity={data?.capacity?.sitting}
						standingCapacity={data?.capacity?.standing}
					/>
					<VenueCard.Activity
						houses={houses}
						venueRepresent={data?.venueType?.venueRepresent}
						venueSetting={getVenuActivity(data)}
					/>
					<div className={`flex items-start w-full justify-between`}>
						<VenueCard.Pricing
							minSpendPricing={venueRental ? venueRental : minSpendPricing}
							showGuests={minSpendPerPerson}
							minSpendPerPerson={minSpendPerPerson}
							showVenueRental={venueRental ? true : false}
						/>
					</div>

					{(compareType === "both" || compareType === "venues") &&
						isCompareMode && (
							<div className="flex justify-between w-full mx-auto items-center ">
								<input
									type="checkbox"
									checked={
										selectedVenues?.find((venue) => venue._id === data._id) ||
										false
									}
									onChange={() => {
										const isSelected = selectedVenues?.find(
											(venue) => venue._id === data._id
										);

										if (!isSelected && selectedVenues.length >= 3) {
											toast.error("Maximum 3 venues can be selected");
											return;
										}
										onSelect(data);
										setCompareType("venues");
										setIsSelectedCompare(!isSelectedCompare);
									}}
									className=" h-5 w-6"
									onClick={(e) => e.stopPropagation()}
								/>
								<span className="text-[16px] text-dark">Compare</span>
							</div>
						)}
					{(enquiryType === "both" || enquiryType === "venues") &&
						isBulkEnquiry && (
							<div className="flex justify-between w-full mx-auto items-center gap-2 ">
								<input
									type="checkbox"
									checked={
										selectedEnquiries?.find(
											(enquiry) => enquiry._id === data._id
										) || false
									}
									onChange={() => {
										onEnquirySelect(data);
										setEnquiryType("venues");
									}}
									className=" h-5 w-6"
									onClick={(e) => e.stopPropagation()}
								/>
								<span className="text-[16px] text-dark">Bulk Enquiry</span>
							</div>
						)}
					{selectedVenues?.length > 0 &&
						isCompareMode &&
						compareType === "venues" && (
							<div className="fixed bottom-0 bg-white left-0 right-0 shadow-md z-50 p-4 px-6 flex items-center overflow-x-auto justify-between gap-4">
								<div className="flex items-center gap-5 overflow-x-auto custom-scrollbar1 px-2 md:px-0">
									<span className="text-dark md:text-[16px] text-[11px]">
										Venues
									</span>
									{selectedVenues?.map((venue) => (
										<div
											key={venue._id}
											className="flex items-center bg-gray-100 shadow-md rounded p-2 md:min-w-60 gap-y-2 gap-x-7 ml-2"
										>
											<SecureImg
												src={getS3Thumb(venue?.imagesAndVideos?.images?.[0])} fallbackSrc={venue?.imagesAndVideos?.images?.[0]}
												alt={venue?.name}
												className="md:h-10 md:w-10 h-6 w-6 object-cover rounded"
											/>
											<span className="md:text-sm font-medium text-xs ">
												{" "}
												{venue?.basicDetails?.venueName || "Undefined"},{" "}
												{venue?.basicDetails?.hotelName || "Undefined"}
											</span>
											<button
												onClick={() => handleRemove(venue?._id)}
												className=" text-lg font-bold focus:outline-none"
											>
												<RxCross2
													size={22}
													className="text-primary cursor-pointer"
												/>
											</button>
										</div>
									))}
								</div>
								<div>
									<div className="flex justify-center items-center gap-4">
										<button
											onClick={handleCompare}
											className="bg-[#FE4747] md:w-auto w-full text-[12px] rounded-lg text-white py-2 md:px-4 px-3 lg:text-[16px] lg:font-[500]"
										>
											Compare
										</button>

										<div>
											<RxCross2
												size={22}
												className="text-primary cursor-pointer"
												onClick={() => {
													setIsSelectedCompare(false);
													clearSelectedVenues();
													setIsCompareMode(false);
													setCompareType("both");
												}}
											/>
										</div>
									</div>
								</div>
							</div>
						)}
					{selectedEnquiries?.length > 0 &&
						isBulkEnquiry &&
						enquiryType === "venues" && (
							<div className="fixed bottom-0 bg-white left-0 right-0 shadow-md z-50 p-4 px-6 flex items-center justify-between gap-4 overflow-x-auto">
								<div className="flex items-center gap-5 overflow-x-auto custom-scrollbar1 px-2 md:px-0">
									<span className="text-dark md:text-[16px] text-[11px]">
										Venues
									</span>
									{selectedEnquiries?.map((venue) => (
										<div
											key={venue._id}
											className="flex items-center bg-gray-100 shadow-md rounded p-2 md:min-w-60 gap-y-2 gap-x-7 ml-2 mb-1"
										>
											<SecureImg
												src={getS3Thumb(venue?.imagesAndVideos?.images[0])} fallbackSrc={venue?.imagesAndVideos?.images[0]}
												alt={venue?.name}
												className="md:h-10 md:w-10 h-6 w-6 object-cover rounded"
											/>
											<span className="md:text-sm font-medium text-xs ">
												{" "}
												{venue?.basicDetails?.venueName || "Undefined"}
											</span>
											<button
												onClick={() => handleEnquiryRemove(venue?._id)}
												className=" text-lg font-bold focus:outline-none"
											>
												<RxCross2
													size={22}
													className="text-primary cursor-pointer"
												/>
											</button>
										</div>
									))}
								</div>
								<div className="flex justify-center items-center gap-4">
									<button
										onClick={handleBulkEnquiry}
										className="bg-[#FE4747] md:w-auto w-full text-[12px] rounded-lg text-white py-2 md:px-4 px-3 lg:text-[16px] lg:font-[500]"
									>
										Send Enquiry
									</button>
									<div>
										<RxCross2
											size={22}
											className="text-primary cursor-pointer"
											onClick={() => {
												setIsBulkEnquiry(false);
												setEnquiryType("");
											}}
										/>
									</div>
								</div>
							</div>
						)}
				</VenueCard.Details>
			</VenueCard>
		</>
	);
};

export default VenueFavoriteDetail;
